import React, { FC, useContext, useEffect, useState } from "react";
import Heading from "components/Heading/Heading";
import { DEMO_POSTS } from "data/posts";
import { PostDataType } from "data/types";
import CommentListing from "components/CommentListing/CommentListing";
// import Pagination from "shared/Pagination/Pagination";
// import ButtonPrimary from "shared/Button/ButtonPrimary";
// import WidgetTags from "./WidgetTags";
// import WidgetCategories from "./WidgetCategories";
// import WidgetPosts from "./WidgetPosts";
// import Card3 from "./Card3";

// import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import ButtonSecondary from "shared/Button/ButtonSecondary";
// import Editor from "./Editor";
import { Link, useNavigate, useParams } from "react-router-dom";
//import Input from "shared/Input/Input";
import { requestAPI } from "utils/api";
import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";
import PostCardMeta from "./PostCardMeta";

import Input from "shared/Input/Input";

import ButtonCircle from "shared/Button/ButtonCircle";
import { ArrowRightIcon, ArrowSmallLeftIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import { GlobalDataContext } from "contexts/GlobalData";
import { UIContext } from "contexts/UIContext";

import SigninForm from "components_custom/SigninForm/SigninForm";

import GuestAvatar from "assets/images/guest.png";
import ReservationCard from "./ProductCard";
import ButtonPrimary from "shared/Button/ButtonPrimary";




const CommunityComments = ({

}: any) => {
	
	const { id } = useParams();

	const {
		toast,
		modal,
	} = useContext (UIContext);  
	const { 
		initData
	} = useContext (GlobalDataContext);

	const [ comments, setComments ] = useState <any> ([]);
	const [ commentContents, setCommentContents ] = useState ("");

	const dataLoad = async () => {
		const res2: any = await requestAPI('GET', `v1/comment/community/${id}`, null);	

		setComments(res2.data.comments);
	}

	useEffect (() => {
		
		(async () => {
			
			await dataLoad();

		})();
	}, []);

	


	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
		
		const formattedTime2 = `${(hours < 10?"0":"")}${hours}:${minutes}`;

		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}.${month}.${day}`;
		
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			time2: formattedTime2,
			year: year,
			month: month,
			day: day,
		};
	};

	const handleCommentSaveRequest = async () => {
		const _commentContents = commentContents;	

		setCommentContents("");

		if (initData.token_info.permission_group === "guest") {


			modal({
				title: "로그인",
				contents: <SigninForm modalSw={true} />,
				buttons: []
			});

			return toast({
				type: 'warning',
				contents: '로그인이 필요해요'
			});
		}

		let isEmpty = fieldEmptyCheck(_commentContents);

		if (isEmpty === "HasEmpty") {
			return toast({
				type: 'warning',
				contents: '내용을 입력해 주세요.'
			});
		}

		setCommentContents("");

		const res: any = await requestAPI('POST', `v1/comment/community/${id}`, {
			commentContents: _commentContents,
		});

		console.log("rrrr ", res.data.commentList);

		setComments([]);
		setComments([...res.data.commentList]);
	};

	const fieldEmptyCheck = (text: string) => {
		//공백이 있으면 true

		const regex = /^\s*$/;

		// console.log(text === '');
		// console.log(text === null);
		// console.log(text === undefined);
		// console.log();

		if (text === '' || text === null || text === undefined || regex.test(text)) {
			return "HasEmpty";
		}

		return 'NoEmpty';
	}

	

	return (
		<div id="comments" className="listingSection__wrap">
			{/* HEADING */}


			{/* Content */}
			<div className="space-y-5">
				{/* <FiveStartIconForRate iconClass="w-6 h-6" className="space-x-0.5" /> */}
				<div className="relative">
					<Input
						value={commentContents}
						onChange={e => setCommentContents(e.target.value)}
						fontClass=""
						sizeClass="h-16 px-4 py-3"
						rounded="rounded-3xl"
						placeholder="질문 또는 후기를 남겨주세요..."
					/>
					<ButtonCircle
						onClick={() => handleCommentSaveRequest()}
						className="absolute right-2 top-1/2 transform -translate-y-1/2"
						size=" w-12 h-12 "
					>
						<ArrowRightIcon className="w-5 h-5" />
					</ButtonCircle>
				</div>
			</div>

			{/* comment */}
			<div className="divide-y divide-neutral-100 dark:divide-neutral-800">
				{
					(comments.length > 0)
					?
						comments.map((item: any, idx: number) => (

							<CommentListing
								key={`comment_list_${idx}`}
								className={"py-8"}
								_id={item._id}
								user_id={item.user_id}
								self_id={initData.token_info.user_id}
								name={item.user_name}
								avatar={item.user_profileUrl}
								date={formatKoreanDate(item.createdAt).date}
								_comment={item.comment}
								dataLoad={dataLoad}
							/>
						))
					:
						<div>아직 코멘트가 없어요</div>
				}

				{/* <div className="pt-8">
			<ButtonSecondary>View more 20 reviews</ButtonSecondary>
		  </div> */}
			</div>
		</div>
	);

};

export default CommunityComments;
